export default __webpack_public_path__ + "static/img_5-9b48caa4c1cecc0cf64f9aa638aaf78d.png";